/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createAsech } from '../../factoriesAny.js';
export var asechDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  ComplexDependencies: ComplexDependencies,
  typedDependencies: typedDependencies,
  createAsech: createAsech
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAsech.generated.js
// module id = 1346
// module chunks = 0